import { createSlice } from '@reduxjs/toolkit'

const INITIAL_STATE = {
    // flow initialisation
    initiatingAdminUpdateFlow: false,
    initiatingAdminUpdateFlowError: "",
    token: null,
    adminUpdateLicenseInitiated: false,

    // update license status
    adminUpdateLicenseInProgress: false,
    adminUpdateLicenseSuccess: false,
    adminUpdateLicenseError: "",

    // document upload status
    documentUploadWorking: false,
    documentUploadSuccess: false,
    documentUploadError: "",

    // flow data
    permitData: {},
    applicationNumber: "",
    licenseNumber: "",
    // only want to get the exisitng account details if we are coming from the Portal Account page
    // If we are arriving at this page from the Owner page, the user  may have updated the registrant details, so we do not want to override them
    fetchedRegistrantDetails: false
}

export const adminUpdateSlice = createSlice({
    name: 'adminUpdate',
    initialState: INITIAL_STATE,
    reducers: {
        setInitiatingAdminUpdateFlowInProgress: (state) => {
            state.adminUpdateLicenseInitiated = false;
            state.initiatingAdminUpdateFlow = true;
            state.initiatingAdminUpdateFlowError = "";
            state.token = null;

            state.documentUploadWorking = false;
            state.documentUploadCompleted = false;
            state.documentUploadError = "";
        },
        setInitiatingAdminUpdateFlowError: (state, action) => {
            state.initiatingAdminUpdateFlow = false;
            state.adminUpdateLicenseInitiated = false;
            state.initiatingAdminUpdateFlowError = action.payload;
            state.token = null;
        },
        setInitiatingAdminUpdateFlowSuccess: (state) => {
            state.initiatingAdminUpdateFlow = false;
            state.initiatingAdminUpdateFlowError = "";
            state.adminUpdateLicenseInitiated = true;
        },
        setAdminUpdateFlowToken: (state, action) => {
            state.token = action.payload;
        },

        startAdminUpdateLicense: (state) => {
            state.adminUpdateLicenseInProgress = true;
            state.adminUpdateLicenseSuccess = false;
            state.adminUpdateLicenseError = "";
            state.documentUploadError = "";
        },
        setAdminUpdateLicenseSuccess: (state) => {
            state.adminUpdateLicenseInProgress = false;
            state.adminUpdateLicenseSuccess = false;
        },
        setAdminUpdateLicenseError: (state, action) => {
            state.adminUpdateLicenseInProgress = false;
            state.adminUpdateLicenseSuccess = false;
            state.adminUpdateLicenseError = action.payload;
        },
        updatePermitData: (state, action) => {
            state.permitData = {
                ...state.permitData,
                ...action.payload,
            }
        },
        setAdminUpdateApplicationNumber: (state, action) => {
            state.applicationNumber = action.payload
        },
        setAdminUpdateLicenseNumber: (state, action) => {
            state.licenseNumber = action.payload
        },
        startDocumentUpload: (state) => {
            state.documentUploadSuccess = false;
            state.documentUploadWorking = true;
            state.documentUploadError = "";
        },
        setDocumentUploadSuccess: (state) => {
            state.documentUploadWorking = false;
            state.documentUploadSuccess = true;
            state.documentUploadError = "";
        },
        setDocumentUploadError: (state, action) => {
            state.documentUploadWorking = false;
            state.documentUploadSuccess = false;
            state.documentUploadError = action.payload;
        },
        removeRegistrantData: (state) => {
            delete state.permitData.registrant;
        },
        resetAdminUpdateState: (state) => INITIAL_STATE,
        setFetchedRegistrantDetails: (state, action) => {
            state.fetchedRegistrantDetails = action.payload;
        },
    },
})

export const {
    setAdminUpdateFlowToken,
    setInitiatingAdminUpdateFlowError,
    setInitiatingAdminUpdateFlowSuccess,
    setInitiatingAdminUpdateFlowInProgress,

    startAdminUpdateLicense,
    setAdminUpdateLicenseSuccess,
    setAdminUpdateLicenseError,

    updatePermitData,
    setAdminUpdateApplicationNumber,
    setAdminUpdateLicenseNumber,
    startDocumentUpload,
    setDocumentUploadSuccess,
    setDocumentUploadError,
    resetAdminUpdateState,

    removeRegistrantData,
    setFetchedRegistrantDetails

} = adminUpdateSlice.actions

export default adminUpdateSlice.reducer
